import React, { useEffect, useRef } from 'react';
import { useHasMetasiteError, useMsId, useStoreName } from '../store/appStore';
import { useBiLogger } from '../hooks/useBiLogger/useBiLogger';
import { GeneralError } from '../components/GeneralError/GeneralError';
import { SitePreviewWrapper } from '../features/sitePreview/SitePreviewWrapper';
import { Box, Loader } from '@wix/design-system';
import { useGTM } from '../hooks/useGTM';
import { DsBuilderMethod } from '../types';
import { useQuerySites } from '../features/sitePreview/api';

type SitePreviewPageProps = {};

export const SitePreview: React.FC<SitePreviewPageProps> = () => {
  const metasiteError = useHasMetasiteError();
  const msId = useMsId();
  const storeName = useStoreName();
  const { refetch: refetchSites, isFetching: isQuerySitesLoading } = useQuerySites();

  const biLogger = useBiLogger();
  const { trackPreviewPageView } = useGTM();
  const hasTracked = useRef(false);

  useEffect(() => {
    if (hasTracked.current) {
      return;
    }

    hasTracked.current = true;

    biLogger.pageView(DsBuilderMethod[DsBuilderMethod.SITE_PREVIEW]);
    trackPreviewPageView(storeName);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [storeName]);

  useEffect(() => {
    refetchSites();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (isQuerySitesLoading || !msId) {
    return (
      <Box height="100%" width="100%" align="center" verticalAlign="middle">
        <Loader />
      </Box>
    );
  }

  if (metasiteError) {
    return <GeneralError />;
  }

  return <SitePreviewWrapper />;
};
